import React from 'react';
import InstituteHero from '../components/Institute/InstituteHero';
import CategoriesBanner from '../components/CategoriesBanner';
import Navbar from '../components/Navbar';
//import Footer from '../components/Footer';
import InstituteAbout from '../components/Institute/InstituteAbout';

function InstitutePage() {
    return (
        <div>
            <CategoriesBanner />
            <Navbar />
            <InstituteHero />
            <InstituteAbout />
            {/* <Footer /> */}
        </div>
    )
}

export default InstitutePage